import quickQuoteRequestInputs from './QuickInputs/quoteInputs'
import detailedQuoteRequestInputs from './DetailedInputs/quoteInputs'

export default [
  ...quickQuoteRequestInputs,
  ...detailedQuoteRequestInputs,
  'home.purchaseDate',
]
